import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'antd-mobile'
import { CSSTransition } from 'react-transition-group'
import { throttle } from './../../assets/js/utils'

import emptyPic from './../../assets/images/list_empty.png'

import './index.less'

class PullUpLoad extends Component {
  static propTypes = {
      pullUpLoad: PropTypes.func,
      emptyJumpLink: PropTypes.string,
      emptyTips: PropTypes.string,
      emptyBtnText: PropTypes.string
  };

  constructor (props) {
      super(props)
      this.state = {
      // 是否显示返回顶部
          isShowGoTop: false,
          // 列表是否为空
          isEmpty: false,
          // 数据加载中
          isLoaing: true,
          // 数据全部加载完毕
          isFinished: false,
          // 是否滑到底部
          isReachBottom: false,
          // 加载次数
          times: 0
      }

      this.pageClientHeight = ''
      this.pageScrollHeight = ''
  }

  UNSAFE_componentWillMount () {
      // 加载数据
      this.props.pullUpLoad()
  }

  componentDidMount () {}

  /**
   * 初始化监听事件
   */
  init () {
      this.pageClientHeight = window.outerHeight
      this.pageScrollHeight = document.body.scrollHeight
      if (this.pageScrollHeight > this.pageClientHeight) {
          const _throttle = throttle()
          window.addEventListener('scroll', e => {
              _throttle(this.listenPageScroll.bind(this, e), 10)
          })
      } else {
          this.setState({
              isFinished: true,
              isReachBottom: true
          })
      }
  }

  /**
   * 监听页面滚动事件
   * @param {Object} e
   */
  listenPageScroll (e) {
      const scrollTop = window.scrollY
      this.pageClientHeight = document.documentElement.clientHeight
      this.pageScrollHeight = document.body.scrollHeight

      if (scrollTop >= this.pageClientHeight * 2) {
          this.setState({
              isShowGoTop: true
          })
      } else {
          this.setState({
              isShowGoTop: false
          })
      }

      this.pageScrollHeight = document.body.scrollHeight
      if (this.state.isFinished) {
          if (scrollTop + this.pageClientHeight >= this.pageScrollHeight - 50) {
              this.setState({
                  isReachBottom: true
              })
          } else {
              this.setState({
                  isReachBottom: false
              })
          }
          return
      }
      if (scrollTop + this.pageClientHeight >= this.pageScrollHeight) {
          this.setState({
              isLoaing: true
          })
          this.props.pullUpLoad()
      }
  }

  /**
   * 数据加载完成
   */
  handleLoaded () {
      this.setState(
          state => {
              return {
                  isLoaing: false,
                  times: state.times + 1
              }
          },
          () => {
              if (this.state.times === 1) {
                  this.init()
              }
          }
      )
  }

  /**
   * 数据全部加载完
   */
  handleFinished () {
      this.setState(state => {
          return {
              isLoaing: false,
              isFinished: true
          }
      })
      setTimeout(() => {
          if (this.state.times === 0) {
              this.setState({
                  isEmpty: true
              })
          }
      }, 100)
  }

  /**
   * 返回顶部
   */
  goTop = () => {
      window.scrollTo(0, 0)
  };

  /**
   * 跳转
   */
  handleClick = () => {
      window.location.href = `${this.props.emptyJumpLink}`
  };

  /**
   * 底部显示内容
   */
  handleFooterText = () => {
      const { isLoaing, isFinished, isReachBottom } = this.state
      if (isLoaing) {
          return (
              <Fragment>
                  <Icon type="loading" />
                  <span>加载中</span>
              </Fragment>
          )
      } else if (isFinished && isReachBottom) {
          return <span>没有更多数据了~</span>
      } else {
          return (
              <Fragment>
                  <i className="icon icon-arrow-top" />
                  <span>上拉查看更多数据</span>
              </Fragment>
          )
      }
  };

  render () {
      const { isShowGoTop, isEmpty } = this.state
      const { emptyTips, emptyBtnText } = this.props
      return (
          <div className="pull-down" id="pullDown">
              {this.props.children}

              {!isEmpty && (
                  <div className="pull-down-footer">{this.handleFooterText()}</div>
              )}

              {isEmpty && (
                  <div className="empty">
                      <img src={emptyPic} alt="" />
                      <p>{emptyTips}</p>
                      <button type="button" onClick={this.handleClick}>
                          {emptyBtnText}
                      </button>
                  </div>
              )}

              <CSSTransition
                  in={isShowGoTop}
                  timeout={500}
                  classNames="fades"
                  unmountOnExit
              >
                  <div className="go-top" onClick={this.goTop} />
              </CSSTransition>
          </div>
      )
  }
}

export default PullUpLoad
